import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/20 bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-59" data-mp="15ddkvgp2i9mp">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-60" data-mp="1jcljo8hbjfqd">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-61" data-mp="1jb228ejxeyn0">
          <span className="inline-flex items-center gap-2" data-id="element-62" data-mp="1t2ydysexqn9p">
            <PickaxeIcon className="h-7 w-7 shrink-0 text-primary" aria-hidden="true" data-id="element-63" data-mp="1t2evnaldhwv5" /> {productBrand}
          </span>
          <span className="mx-auto mt-3 block w-fit rounded-lg bg-cta px-3 py-1 text-lg font-extrabold uppercase tracking-[.16em] text-cta-foreground sm:text-xl" data-id="element-64" data-mp="1o5y6qe6cneh0">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-muted" data-id="element-65" data-mp="n5m7g5iysa3g">
          Created by mining, geology, and materials technical specialists, for professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-66" data-mp="x3s68e9h5043">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-67" data-mp="120scap6bq2v7">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-68" data-mp="1b3a1nch9zbmf">
              <CheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-69" data-mp="1b16zju2uls1c" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}